import React from "react";
import Cta from "@qlik/qlik/src/components/Cta";
import Media from "@qlik/qlik/src/components/Media";
import { getSpacingClassName } from "@qlik/qlik/src/lib/util/spacing";
import { getColorClassName } from "@qlik/qlik/src/lib/util/colors";
import { renderSanitizedHtmlContent } from "@qlik/qlik/src/lib/util/helpers";
import * as styles from "./styles.module.css";

/**
 * LeftRightPromo component.
 * Renders a promo with content on the left and media on the right.
 * @param {Object} data - The data for the component.
 */
const LeftRightPromo = ({ data }) => {
    const { additionalConfiguration, cardItem, customId, backgroundColor, backgroundImage } = data ?? {};
    const { eyebrowText, title, description, cta, media } = cardItem ?? {};
    const sectionSpacingClassName = getSpacingClassName(
        additionalConfiguration,
        "pt-none lg:pt-none pb-none lg:pb-none mt-s lg:mt-xl mb-s lg:mb-xl"
    );
    const { sectionColorMapping } = getColorClassName(backgroundColor);

    return (
        <section className={`${sectionSpacingClassName} ${sectionColorMapping.bgColor} overflow-hidden`} id={customId}>
            <div
                className={styles.bgImage}
                style={{
                    backgroundImage: `url(${
                        backgroundImage && Array.isArray(backgroundImage) ? backgroundImage[0]?.secure_url : null
                    })`,
                }}
            >
                <div className="container">
                    <div className="row">
                        <div className="col-12 md:col-6 py-15 relative z-2 md:pr-6 xl:pr-10 md:pl-4 md:flex md:justify-center md:flex-col">
                            {eyebrowText && (
                                <p className={`${sectionColorMapping.primaryTextColor} text-xl lg:text-3xl mb-5`}>
                                    {eyebrowText}
                                </p>
                            )}
                            <h1
                                className={`${sectionColorMapping.primaryTextColor} mb-3.75 lg:mb-7.5 text-6xl lg:text-7xl`}
                                // eslint-disable-next-line react/no-danger
                                dangerouslySetInnerHTML={{ __html: renderSanitizedHtmlContent(title) }}
                            />
                            {description?.description && (
                                <p
                                    className={`${sectionColorMapping.primaryTextColor} text-xl lg:text-2xl font-light tracking-tight3 md:tracking-tight5 leading-relaxed mb-3.75 lg:mb-7.5`}
                                >
                                    {description.description}
                                </p>
                            )}
                            {cta?.map((button) => (
                                <div className="flex gap-2" key={button.id}>
                                    <Cta key={button.id} data={button} className="py-3.75 tracking-normal" />
                                </div>
                            ))}
                        </div>
                        {(media?.[0]?.desktopMedia.length || media?.[0]?.mobileMedia.length) > 0 && (
                            <div className="col-12 md:col-6 relative py-0 md:py-15 xl:py-0 px-0 md:pl-6 xl:pl-8">
                                <Media media={media[0]} className="object-contain md:max-w-full md:w-auto h-auto" />
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default LeftRightPromo;
